import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtInt } from "@/lib/format";
import { useAuth } from "@/lib/auth";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Eye } from "lucide-react";

export default function CriticalStock() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/stock/critical").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-4">
      <div className="azd-card p-5 flex items-center gap-4">
        <div className="w-12 h-12 rounded-lg bg-[#F59E0B]/10 text-[#F59E0B] flex items-center justify-center">
          <AlertTriangle size={22} />
        </div>
        <div className="flex-1">
          <div className="text-xs uppercase tracking-wider font-bold text-[#6B7280]">
            Toplam
          </div>
          <div className="text-2xl font-extrabold text-[#08285A]">
            {items.length} ürün kritik seviyede
          </div>
        </div>
      </div>

      <div className="azd-card overflow-hidden">
        <div className="overflow-x-auto azd-scrollbar">
          <table className="w-full text-sm">
            <thead className="bg-[#F6F8FB] text-[11px] uppercase tracking-wider text-[#6B7280]">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Kod</th>
                <th className="text-left px-4 py-3 font-semibold">Ürün Adı</th>
                <th className="text-right px-4 py-3 font-semibold">Mevcut</th>
                <th className="text-right px-4 py-3 font-semibold">Kritik</th>
                <th className="text-right px-4 py-3 font-semibold">Eksik</th>
                <th className="text-center px-4 py-3 font-semibold">Durum</th>
                <th className="text-right px-4 py-3 font-semibold"></th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr><td colSpan={7} className="p-8 text-center text-[#6B7280]">
                  Kritik stokta ürün bulunmuyor 🎉
                </td></tr>
              ) : items.map((p) => {
                const cs = Number(p.current_stock || 0);
                const crit = Number(p.critical_stock_level || 0);
                const eksik = Math.max(0, crit - cs);
                const status = cs <= 0 ? "out" : "critical";
                return (
                  <tr key={p.id} className="border-t border-[#E5E7EB] hover:bg-[#F6F8FB]/50">
                    <td className="px-4 py-3 font-mono text-xs text-[#0B3676]">{p.product_code}</td>
                    <td className="px-4 py-3 font-semibold text-[#111827]">{p.product_name}</td>
                    <td className="px-4 py-3 text-right font-bold text-[#08285A]">
                      {fmtInt(cs)} {p.unit}
                    </td>
                    <td className="px-4 py-3 text-right text-xs text-[#6B7280]">{fmtInt(crit)} {p.unit}</td>
                    <td className="px-4 py-3 text-right font-bold text-[#DC2626]">
                      {fmtInt(eksik)} {p.unit}
                    </td>
                    <td className="px-4 py-3 text-center"><StatusBadge status={status} /></td>
                    <td className="px-4 py-3 text-right">
                      <Button size="sm" variant="outline" onClick={() => navigate(`/products/${p.id}`)}>
                        <Eye size={14} className="mr-1" /> Görüntüle
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
